module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jean Toomer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jean Toomer was an African American poet and novelist commonly associated with the Harlem Renaissance, though he actively resisted the association, and modernism. His reputation stems from his only book, the novel "), _c('I', [_vm._v("Cane")]), _vm._v(", which Toomer wrote during and after his time as a school principal in Sparta, Georgia.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xVZTjy/tc-custom/9781504058391.jpg?1721429532283",
      "alt": "This image is the cover for the book Cane"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cane\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A lyrical “groundbreaking work” of the Harlem Renaissance, praised by writers from Langston Hughes to Maya Angelou and Alice Walker ("), _c('i', [_vm._v("The Washington Post")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “It would be good to hear their songs . . . reapers of the sweet-stalked cane, cutters of the corn . . . even though their throats cracked, and the strangeness of their voices deafened me.” —“Harvest Song,” Jean Toomer"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Published in 1923, Jean Toomer’s "), _c('i', [_vm._v("Cane ")]), _vm._v("has long been recognized as a pioneering work in African American literature. Employing a modernist, nontraditional structure of thematically linked prose vignettes, poems, and dialogue presented in evocative, often mournful lyrical tones, Toomer created a unique impressionistic mosaic of the inner lives of African Americans in the early twentieth century, encompassing the rural South and the urban North. Deeply felt and beautifully expressed, Toomer’s masterpiece continues to resonate almost a century after it was written."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("This ebook has been professionally proofread to ensure accuracy and readability on all devices.")]), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Boni & Liveright, Inc.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0